import gql from 'graphql-tag'

const deleteEducationMutation = gql`
  mutation deleteEducation($id: String!) {
    deleteEducation(id: $id)
  }
`

export default deleteEducationMutation
